import type { TourStep } from '../types';
export const designerPdfUploadSteps: TourStep[] = [
  { target: '[data-tour="designer-upload-dropzone"]', title: 'Добавьте PDF', content: 'Перетащите файлы сюда или выберите их на компьютере.' },
  { target: '[data-tour="designer-upload-rows"]', title: 'Проверьте файлы', content: 'Перед отправкой убедитесь, что выбраны нужные макеты.' },
  { target: '[data-tour="designer-upload-rows"]', title: 'Лимит загрузки', content: 'Количество файлов не должно превышать остаток по плану.' },
  { target: '[data-tour="designer-upload-submit"]', title: 'Отправьте макеты', content: 'Запустите загрузку и дождитесь её завершения.' },
];
